import { WithErrorTooltip } from 'components/shared/WithErrorTooltip/WithErrorTooltip';
import { NextWorkflowError } from 'models/NextWorkflowError';
import { QuoteWarning } from 'models/QuoteWarning';

type UnsuccessfulPriceButtonProps = {
  label: string;
  errors: NextWorkflowError[];
  warnings?: QuoteWarning[];
  productSubtype?: string;
  onClick?: () => void;
};

const UnsuccessfulPriceButton = ({
  label,
  onClick,
  errors,
  warnings,
  productSubtype,
}: UnsuccessfulPriceButtonProps) => {
  return (
    <div className="price-button-container py-1">
      <button onClick={onClick} className="btn btn-flat-danger h-100 btn-icon-end justify-content-between w-100">
        {label}

        <WithErrorTooltip
          errors={errors}
          productSubtype={productSubtype}
          warnings={warnings}
          errorTitle="smartQuote.workspace.main.priceButton.errorDetails.tooltipTitle"
          hideTooltipOnStartup
        >
          <i aria-hidden="true" className="icon">
            block
          </i>
        </WithErrorTooltip>
      </button>
    </div>
  );
};

export default UnsuccessfulPriceButton;
